
import Vue from "vue";
import {AdminApiKey} from "@/models/admin-api-key";
import {AdminApiKeyService} from "@/services/admin-api-key-service";

export default Vue.extend({
	data(){
		return {
			keys: [] as AdminApiKey[],
			createApiKeyModal: false,
			newApiKeyName: "",
			createdApiKey: ""
		};
	},
	methods: {
		async fetch(){
			this.keys = await AdminApiKeyService.getApiKeys();
		},
		async deleteKey(key:AdminApiKey){
			let confirm = await this.$wf.confirm(`Weet u zeker dat u de api key '${key.name}' wilt verwijderen`, "Ja", "Nee", "Waarschuwing", "warning");
			if (!confirm) return;
			await AdminApiKeyService.deleteApiKey(key.id);
			this.fetch();
		},
		openApiKeyModal(){
			this.createApiKeyModal = true;
			this.newApiKeyName = "";
		},
		async createApiKey(){
			let result = await AdminApiKeyService.createApiKey(this.newApiKeyName);
			this.createdApiKey = result.key;
			this.createApiKeyModal = false;
			await this.fetch();
		},
		async onCreatedApiKeyInput(){
			let key = this.createdApiKey;
			this.createdApiKey = "asdhiagfuhafs";
			await this.$nextTick();
			this.createdApiKey = key;
		},
		copyCreatedApiKeyToClipboard(){
			let el = this.$refs.createdApiKeyRef as Vue;
			if (!el) return;
			let inputs = el.$el.getElementsByTagName("input");
			for (let input of inputs){
				input.select();
				input.setSelectionRange(0, 999999);
				document.execCommand("copy");
				this.$wf.notify("Key gokopieerd naar klembord", "success", 3000, "check");
			}
		},
		closeCreatedApiKey(){
			this.createdApiKey = "";
		}
	},
	created(){
		this.fetch();
	}
});
